import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'jump-badge',
  styleUrl: 'jump-badge.scss',
  shadow: true,
})
export class AppBadge {
  /**
   * Indicates the label of the badge
   */
  @Prop() label: string = '';

  /**
   * Indicates the variant of the badge
   */
  @Prop({reflect: true}) variant: 'primary'|'secondary'|'neutral'|'warning'|'success'|'danger' = 'primary';

  /**
   * Indicates the variant of the badge
   */
  @Prop({reflect: true}) dimension: 'large'|'small'|'dot'|'microdot' = 'large';

  /**
   * Indicates the variant of the badge
   */
  @Prop({reflect: true}) soft: boolean = false;

  /**
   * Indicates the variant of the badge
   */
  @Prop({reflect: true}) outline: boolean = false;

  render() {
    return (
      <Host>
        <slot name="prefix"></slot>
        {this.label}
      </Host>
    );
  }

}
